import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { ConfirmationService, MessageService } from "primeng/api";
import { environment } from "src/environments/environment";
import { MyserviceService } from "../myservice.service";
import { DatePipe } from "@angular/common";

@Component({
    selector: "app-partner",
    templateUrl: "./partner.component.html",
    styleUrls: ["./partner.component.css"],
    providers: [MessageService,ConfirmationService],
})
export class PartnerComponent implements OnInit {
    rowsNo = 0;
    offset:number = 0;
    pageSize:number = 10;
    noOfRecords: number=0;
    hasSearched=false;
    sortField: String="createdDate";
    sortOrder: number = -1;
    loader:boolean;
    display: boolean;
    responseMsg: boolean = false;
    statusArray = [];
    updateDocument: any = {};
    partnerData: any = [];
    partnerInfo: any = [];
    updateInfo: any = [];
    addPartnerForm: FormGroup;
    detailInfoPartnerForm: FormGroup;
    public show: boolean = false;
    public show1: boolean = false;
    public responseViewTime: boolean = false;
    public count = 0;
    resultMessage = "";
    updateResponse = "";
    userRole: string;
    tableHeaders: { field: string; header: string; width: string; }[];
    roleId: any;
    headers:HttpHeaders
    addPartnerAccess: any=false;
    isProd:boolean=environment.prod;
    constructor(
        private service: MyserviceService,
        public session: SessionStorageService,
        public localstorage: LocalStorageService,
        public datepipe: DatePipe,
        private http: HttpClient,
        private fb: FormBuilder,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
    ) {
        let headers = new HttpHeaders();
        this.headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
    }

    ngOnInit() {
        this.roleId = this.session.retrieve("UserDetails").roleId;
        this.userRole = this.session.retrieve("userRole");
        this.addPartnerAccess=this.session.retrieve("UserDetails").addPartnersAccess;
        this.addPartnerForm = this.fb.group({
            partnerName: new FormControl("", Validators.required),
            status: new FormControl("", Validators.required),
            partnerIdentifier: new FormControl("", Validators.required),
            countryCode: new FormControl("", Validators.required),
        });

        this.detailInfoPartnerForm = this.fb.group({
            partnerIdentifier: new FormControl("", Validators.required),
            partnerName: new FormControl("", Validators.required),
            status: new FormControl("", Validators.required),
            countryCode: new FormControl("", Validators.required),
        });

        this.statusArray.push({ label: "Select", value: "-1" });
        this.statusArray.push({ label: "ACTIVE", value: "ACTIVE" });
        this.statusArray.push({ label: "INACTIVE", value: "INACTIVE" });

        this.tableHeaders = [
            { field: "partnerName", header: "Name",width:"10%" },
            { field: "partnerIdentifier", header: "Partner Id",width:"7%" },
            { field: "countryCode", header: "Country",width:"7%" },
            { field: "status", header: "Status",width:"6%" },
            { field: "createdDate", header: "Created on",width:"10%" },
        ];
        if (this.roleId == 1) {
            this.tableHeaders.push({ field: "", header: "Delete Account", width: "7%" })
        }
    }

    search(countFlag = false) {
        this.hasSearched=true;
        let document={...this.addPartnerForm.value};
        document.limit=this.pageSize;
        document.offSet=this.offset;
        document.sortField=this.sortField;
        document.sortOrder= this.sortOrder == 1 ? "ASC" : "DESC";
        document.countFlag = countFlag;
        this.loader=true;
        this.partnerData = [];
        this.http
            .post(environment.apiUrl + "/partner/search", document, {
                headers: this.headers,
            })
            .subscribe((res:any) => {
                this.partnerData = res.data;
                if (countFlag) {
                    this.noOfRecords = res.totalRecordsCount;
                }
                this.loader=false;
            });
    }
    //For server side pagination and sorting
    onPagination(data) {
        this.rowsNo = data.first + data.rows >= this.noOfRecords ? this.noOfRecords : data.first + data.rows;
        //Checking if the previous pagination and sorting fields are different with latest fields or not to reduce the API hits
        if (data.first != this.offset || data.rows != this.pageSize || data.sortField != this.sortField || data.sortOrder != this.sortOrder) {
            this.offset = data.first;
            this.pageSize = data.rows;
            this.sortField = data.sortField;
            this.sortOrder = data.sortOrder;
            this.search();
        }
    }

    details(partnerIdentifier) {
        this.display = true;
        this.partnerInfo = [];
        this.http
            .get(environment.apiUrl + "/partner/info/" + partnerIdentifier, {
                headers: this.headers,
            })
            .subscribe((data) => {
                this.partnerInfo = data;
                this.detailInfoPartnerForm.controls.partnerIdentifier.setValue(
                    this.partnerInfo.partnerIdentifier
                );
                this.detailInfoPartnerForm.controls.partnerName.setValue(
                    this.partnerInfo.partnerName
                );
                this.detailInfoPartnerForm.controls.status.setValue(
                    this.partnerInfo.status
                );
                this.detailInfoPartnerForm.controls.countryCode.setValue(
                    this.partnerInfo.countryCode
                );
            });
    }

    close() {
        this.display = false;
        this.partnerInfo = [];
    }

    add(documentForm) {
        let document = documentForm.value;
        this.http
            .post(environment.apiUrl + "/partner/add", document, {
                headers: this.headers,
                responseType: "text",
            })
            .subscribe((data) => {
                this.resultMessage = data;
                if (this.resultMessage == "Partner Id already existed!" || this.resultMessage =="") {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: this.resultMessage,
                    });
                } else {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: this.resultMessage,
                    });
                }
                this.responseViewTime = true;
                setTimeout(
                    function () {
                        this.responseViewTime = false;
                    }.bind(this),
                    2000
                );
                this.addPartnerForm.reset();
                this.setDefaultPagination();
                this.search(true);
            });
    }

    update(partnerInfo) {
        this.updateResponse = "";
        this.updateInfo = partnerInfo;
        this.http
            .post(environment.apiUrl + "/partner/update", this.updateInfo, {
                headers: this.headers,
                responseType: "text",
            })
            .subscribe((data) => {
                this.updateResponse = data;
                this.addPartnerForm.reset();
                this.setDefaultPagination();
                this.search(true);
                this.responseMsg = true;
                setTimeout(
                    function () {
                        this.responseMsg = false;
                    }.bind(this),
                    2000
                );
            });
    }
    setDefaultPagination(){
        this.hasSearched = false;
        this.offset = 0;
        this.pageSize = 10;
        this.noOfRecords = 0;
        this.sortField = "createdDate";
        this.sortOrder = -1;
    }
    reset() {
        this.setDefaultPagination();
        this.addPartnerForm.reset();
        this.partnerData = [];
    }
    
    //to generate the excel report
    generateExcel() {
        let document={...this.addPartnerForm.value};
        document.sortField=this.sortField;
        document.sortOrder= this.sortOrder == 1 ? "ASC" : "DESC";
        document.countFlag=false;
        let fileName = "PartnersReport_" + this.datepipe.transform(this.service.getDateByTZ(), "ddMMyyyy_HHmm", "+0000") + ".xlsx"
        this.service.downloadPartnerReport(
            "/partner/partnersExcelDownload",
            document,
            fileName,
            this.headers
        );
    }

    deleteAccount(id:any) {
        this.confirmationService.confirm({
            message: `Are you sure that you want to delete?`,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            key: "positionDialog",
            accept: () => {
                this.loader = true;
                let headers = new HttpHeaders();
                headers = headers.append(
                    "authorization",
                    this.localstorage.retrieve("token")
                );
                this.http.delete(environment.apiUrl + "/partner/delete", { headers: headers, params: { partnerId: id },responseType:"text" })
                    .subscribe((data: any) => {
                        this.loader = false;
                        if (data == "Partner deleted seccessfully") {
                            this.setDefaultPagination();
                            this.search(true);
                            this.messageService.add({
                                severity: "success",
                                detail: "Partner deleted seccessfully",
                            });
                        } else {
                            this.messageService.add({
                                severity: "error",
                                detail: data,
                            });
                        }
                    });
            },
            reject: () => {
            }
        });
    }
}
